import React from 'react';
import {Link} from 'react-router';
import DanhSachTaiLieuDinhKem from './DanhSachTaiLieuDinhKem.jsx';
import moment from 'moment';
import { DropDownChonQuyTrinhGiaiQuyetDon } from 'components/tt-forms';
import { GiaiQuyetDonThu } from 'api';
import {TextArea} from 'components/tt-forms/common';

class GiaiQuyetDonCanBoNhapLieu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.id,
      btnLoading: false,
      thongTinGiaiQuyetDon: this.props.thongTinGiaiQuyetDonId,
      nextState: 'VAN_THU_CHUYEN_DON_VI_TTXM',
      yKienGiaiQuyet: '',
      listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
      donViThamTraXacMinhInfo: [],
      ngayHetHanTTXM: ''
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDon);
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
    this.props.handleChangeData();
  }

  onClickClose() {
    this.props.handleBack();
  }

  getThongTinGiaiQuyetDon(id) {
    let params = {
      id: id
    };
    GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
      if(res.data) {
        this.setState({
          donViThamTraXacMinhInfo: res.data.donViThamTraXacMinhInfo,
          ngayHetHanTTXM: new Date(res.data.ngayHetHanTTXM)
        });
      }
    });
  }

  handleGiaiQuyetDon() {
    this.setState({
      btnLoading: true
    })
    let selectedState = this.props.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });
    let params = {
      thongTinGiaiQuyetDon: {
        id: Number(this.state.thongTinGiaiQuyetDon)
      },
      nextState: {
        id: Number(selectedState[0].stateId)
      },
      yKienGiaiQuyet: this.state.yKienGiaiQuyet
    }
    this.props.postGiaiQuyetDon(params);
  }

  render() {
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    return (
      <section className="wrap-block">
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        <div className="row pl10 pr10">
          <DropDownChonQuyTrinhGiaiQuyetDon className="clear-left" donId={this.state.id} require isValid={this.state.isValid} selectedValue={this.state.nextState} onChange={this.onChange.bind(this, 'nextState')}/>
          <div className="col-100 no-gutter">
            <div className="col-25">
              <span className="val-title-bold">Đơn vị {lb1}:</span>
              <span className="val-content">{(this.state.donViThamTraXacMinhInfo) ? this.state.donViThamTraXacMinhInfo.ten : ''}</span>
            </div>
            <div className="col-25">
              <span className="val-title-bold">Thời gian báo cáo kết quả:</span>
              <span className="val-content">{(this.state.ngayHetHanTTXM) ? moment(this.state.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}</span>
            </div>
          </div>
          <div className="col-100">
            <DanhSachTaiLieuDinhKem listTaiLieuVanThuGiaiQuyetDon={this.state.listTaiLieuVanThuGiaiQuyetDon}/>
          </div>
          <TextArea label="Ý kiến xử lý" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')}/>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? "btn-action btn-move action-todo btn-loading-inline" : "btn-action btn-move action-todo"} onClick={this.handleGiaiQuyetDon.bind(this)}><span>Chuyển</span></Link>
          </div>
        </div>
      </section>
    );
  }
}

export default GiaiQuyetDonCanBoNhapLieu;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/GiaiQuyetDonCanBoNhapLieu.jsx